import Template from './template';

export default class TemplateSelection {
    public constructor(
        public readonly template: Template,
        public readonly depth: number,
    ) { }
}
